module.exports = "/assets/data/6b9c3c0679d15c2901669eef5beacd72-SO24.data.json";